import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import FormControllerProxy from 'lib/form/controller_proxy';
import Input from 'views/ui/form_elements/input';
import classnames from 'classnames';
import { t } from 'services/translation';
import { Cap } from 'views/anyguide/messages/styles';
import { PhoneNumberInput } from 'ui_system/inputs/PhoneNumberInput';

const Personal = createReactClass({
  displayName: 'CheckoutPersonal',
  mixins: [FormControllerProxy],

  propTypes: {
    fields: PropTypes.object,
    errors: PropTypes.object,
    onChange: PropTypes.func,
    guideName: PropTypes.string.isRequired,
    borderless: PropTypes.bool,
    fieldsToHide: PropTypes.array,
    is_booking_invoice: PropTypes.bool,
    isLiveBooking: PropTypes.bool,
    googleTagManagerCheckoutProgress: PropTypes.func,
  },

  componentDidMount() {
    this.personalInfo.addEventListener(
      'focus',
      () => this.props.googleTagManagerCheckoutProgress(2),
      {
        capture: true,
        once: true,
      }
    );
  },

  getDefaultProps() {
    return {
      borderless: false,
      fieldsToHide: [],
    };
  },

  nameBlured(name) {
    if (this.props.fields.get(`cardholder_${name}`) === null) {
      this.props.onChange(`cardholder_${name}`, this.props.fields.get(name));
    }
  },

  emailChange(propName, value) {
    const emailValue = value || '';

    // make sure email address has no lead/trail spaces
    this.props.onChange('email', emailValue.trim());
  },

  renderNameAndEmail() {
    const { fieldsToHide, is_booking_invoice, isLiveBooking, isAffiliate } =
      this.props;
    const hideAll = ['name', 'email'].every((field) =>
      fieldsToHide.includes(field)
    );
    if (hideAll) return null;
    return (
      <div>
        {!fieldsToHide.includes('name') && (
          <div className="row">
            <form autoComplete="off">
              <label htmlFor="firstName" id="name-field">
                {isAffiliate ? t('GUEST_NAME') : t('NAME')}
              </label>
              <div className="double-column">
                <div className="column">
                  <Input
                    {...this._formProps('first_name', {
                      'data-testid': 'firstname-input',
                      placeholder: t('FIRST'),
                      onBlur: () => this.nameBlured('first_name'),
                      id: 'firstName',
                      ariaLabelledBy: 'name-field',
                    })}
                  />
                </div>
                <div className="column">
                  <Input
                    data-testid="lastname-input"
                    {...this._formProps('last_name', {
                      placeholder: t('LAST'),
                      onBlur: () => this.nameBlured('last_name'),
                      ariaLabelledBy: 'name-field',
                    })}
                  />
                </div>
              </div>
            </form>
          </div>
        )}
        {!fieldsToHide.includes('email') && (
          <div className="row">
            <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
              <label htmlFor="email" id="email-field">
                {isAffiliate ? t('GUEST_EMAIL_ADDRESS') : t('EMAIL_ADDRESS')}
              </label>
              {!isLiveBooking && !isAffiliate && (
                <p className="hint">
                  {this.props.emailSubtext
                    ? this.props.emailSubtext
                    : t('RECEIPTS_AND_NOTIFICATIONS')}
                </p>
              )}
              {!isLiveBooking && isAffiliate && (
                <p className="hint">{t('IF_EMAIL_PROVIDED')}</p>
              )}
              <Input
                {...this._formProps('email', {
                  'data-testid': 'email-input',
                  placeholder: `${t('EG')} ${t('EMAIL').toLowerCase()}@${t(
                    'EXAMPLE'
                  )}.com`,
                  type: 'email',
                  onChange: this.emailChange,
                  id: 'email',
                  ariaLabelledBy: 'email-field',
                })}
              />
            </form>
          </div>
        )}
        <Input
          {...this._formProps('guest_invoiced', {
            type: 'hidden',
            value: is_booking_invoice,
          })}
        />
        <Input
          {...this._formProps('is_live_booking', {
            type: 'hidden',
            value: is_booking_invoice,
          })}
        />
      </div>
    );
  },

  render() {
    const phoneError = this.props.errors.get('phone');
    const containerClasses = classnames('CheckoutPersonal', 'CheckoutSection', {
      'no-bottom-border': !!this.props.borderless,
      'is-live': this.props.isLiveBooking,
    });
    const phoneWrapperClasses = classnames('phone-wrapper', {
      error: phoneError,
    });
    const { showZipCodeOnLive, isLiveBooking, isAffiliate } = this.props;

    return (
      <div
        className={containerClasses}
        ref={(c) => {
          this.personalInfo = c;
        }}
      >
        {this.props.fieldRequirementsSubtext && (
          <p className="field-requirements-subtext hint">
            {this.props.fieldRequirementsSubtext}
          </p>
        )}
        <h2>
          {!isLiveBooking && <span className="step">1</span>}
          {isAffiliate ? t('GUEST_INFORMATION') : t('YOUR_INFORMATION')}
        </h2>
        <div>
          {this.renderNameAndEmail()}
          <div className="row">
            <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
              <label htmlFor="phone" id="phone-field">
                {isAffiliate ? `${t('GUEST_PHONE')} ` : `${t('PHONE')} `}
                {!this.props.phoneMandatory && <Cap>({t('OPTIONAL')})</Cap>}
              </label>
              <p className="hint">
                {this.props.phoneSubtext ? (
                  this.props.phoneSubtext
                ) : (
                  <>
                    {t(
                      'BY_PROVIDING_TOUR_PHONE_NUMBER_YOU_AGREE_TO_RECEIVE_SMS_MESSAGES_RELATED_TO_THIS_BOOKING'
                    )}
                  </>
                )}
              </p>
              <div className={phoneWrapperClasses}>
                <PhoneNumberInput
                  phoneNumber={this.props.fields.get('phone')}
                  setPhoneNumber={(val) => {
                    this.props.onChange('phone', val);
                  }}
                  countryCode={this.props.countryCode}
                  hasError={!!phoneError}
                  dataTestId="country-code-selector"
                  id="phone"
                  ariaLabelledBy="phone-field"
                />
                <span>{t(phoneError && phoneError[0])}</span>
              </div>
              {this.props.isLiveBooking && showZipCodeOnLive && (
                <div style={{ marginTop: 30 }}>
                  <label id="zipcode-field">{t('ZIP_POSTAL_CODE')}</label>
                  <Input
                    type="text"
                    data-testid="zip-input"
                    {...this._formProps('zip_code', {
                      maxLength: 15,
                    })}
                    aria-labelledby="zipcode-field"
                  />
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  },
});

export default Personal;
